import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: '/transfers/init/:appSlug',
    component: () => import('../views/Transfer/Run.vue'),
    name: 'transferRun',
    meta: {
      auth: true
    },
  },
  {
    path: "/",
    component: Layout,
    meta: {
      auth: true
    },
    children: [
      {path: "", name: "dashboard", component: () => import('../views/Dashboard.vue')},
      {
        path: "/applications",
        name: "application",
        props: true,
        meta: {roles: ["ROLE_ADMIN", "ROLE_COMPTA", "ROLE_CLIENT"]},
        component: () => import('../views/Application/Index.vue')
      },
      {path: "/payments", name: "payment", props: true, component: () => import('../views/Payment/Index.vue')},
      {
        path: "/provisions",
        name: "provision",
        props: true,
        component: () => import('../views/Provision/Index.vue')
      },
      {path: "/profile", name: "profile", props: true, component: () => import('../views/Profile/Index.vue')},
      // {
      //   path: "/jobs",
      //   name: "jobs",
      //   props: true,
      //   meta: {roles: ["ROLE_ADMIN"]},
      //   component: () => import('../views/Jobs/Index.vue')
      // },
      {
        path: "/users",
        name: "users",
        meta: {roles: ["ROLE_ADMIN", "ROLE_COMPTA"]},
        component: () => import('../views/Users/Index.vue')
      },
      {path: "/transfers", name: "transfer", props: true, component: () => import('../views/Transfer/Index.vue')}
    ]
  },
  {
    path: "/403",
    name: "forbidden",
    meta: {auth: true},
    component: () => import('../views/Exception/403')
  },
  {
    path: "/404",
    name: "notfound",
    component: () => import('../views/Exception/404')
  },
  {
    path: '/login',
    component: () => import('../views/Security/Login.vue'),
    name: 'login'
  },
  {
    path: "*",
    redirect: {name: "notfound"}
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

Vue.router = router;

export default router
